<template>
    <div>
        <h3 class="mt-3">{{index + 1}} - {{question.translation.name}}</h3>
        <template v-if="question.answer">
            <Badge v-if="exerciseWaiting" class="mb-2" type="info">
                <i style="color: #FFF" class="mdi mdi-clock-outline"></i>
                <span style="color: #FFF">{{$t('lesson.exercise_waiting')}}</span>
            </Badge>
            <Badge v-else-if="!question.approve" class="mb-2" type="success">
                <i :style="{color: '#FFF'}" class="mdi mdi-check-all"></i>
                <span :style="{color: '#FFF'}">{{$t('lesson.exercise_revised')}}</span>
            </Badge>
            <template v-else>
                <Badge v-if="question.answer.approve_question" class="mb-2" type="success">
                    <i :style="{color: '#FFF'}" class="mdi mdi-check-all"></i>
                    <span :style="{color: '#FFF'}">{{$t('lesson.approved')}}</span>
                </Badge>
                <Badge v-else class="mb-2" type="danger">
                    <i :style="{color: '#FFF'}" class="mdi mdi-check-all"></i>
                    <span :style="{color: '#FFF'}">{{$t('lesson.reproved')}}</span>
                </Badge>
            </template>
            <div v-if="question.answer.justify_obs">
                <h4>{{$t('lesson.obs')}}</h4>
                <p class="text-muted">
                    <i class="justify" v-html="question.answer.justify_obs"></i>
                </p>
                <div class="d-flex justify-content-end">
                    <h4>
                        {{$t('lesson.revised_by')}}
                        <span
                            class="text-muted ml-1"
                        >{{question.answer.justified_by}}</span>
                    </h4>
                </div>
            </div>
            <div v-if="this.question.answer.correction_date">
                <h4 class="d-flex justify-content-end">
                    {{$t('lesson.corrected_on')}}:
                    <span
                        class="text-muted ml-1"
                    >{{ formatDate(this.question.answer.correction_date) }}</span>
                </h4>
            </div>
        </template>
        <span
            v-if="question.translation.description"
            class="mb-3 d-block"
            v-html="question.translation.description"
        ></span>
        <p
            style="font-style: italic"
            v-if="question.translation.observation"
            class="mb-3 d-block"
        >{{question.translation.observation}}</p>
        <Editor
            v-if="!isFinished"
            class="nch--html-editor"
            v-model="answer"
            v-validate="'required'"
            :name="$t('lesson.answer_placeholder')"
            :error="errors.first($t('lesson.answer_placeholder'))"
        ></Editor>
        <p v-else class="answer" v-html="answer"></p>
    </div>
</template>

<script>
import debounce from "../../helpers/helpers";
import Badge from "../../argon/components/Badge";
import Editor from '../../argon/components/Inputs/HtmlEditor'

import formatDate from '../../mixins/FormatDate';

export default {
    name: "ExerciseDissertation",
    mixins: [formatDate],
    data() {
        return {
            answer: "",
            model: "",
            firstLoad: false
        };
    },
    components: {
        Badge,
        Editor
    },
    props: {
        question: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        isFinished: {
            type: Boolean
        }
    },
    watch: {
        answer: debounce(function() {
            if (!this.isFinished) {
                this.submitAnswer();
            }
        }, 500),

        question(newVal){
            if(!newVal.answer && !this.isFinished && this.answer){
                this.submitAnswer();
            }
        }
    },
    methods: {
        async submitAnswer() {
            var response = await this.$store.dispatch("SUBMIT_OPTION", {
                exerciseId: this.exercise.id,
                questionId: this.question.id,
                answer: this.answer
            });

            if (!response) {
                this.model = '';
                this.answer = '';
                this.$notify({
                    type: 'danger',
                    message: this.$t('content.exercise.error.no_connection'),
                });
            }
        }
    },
    computed: {
        exerciseWaiting() {
            if (this.question.answer == this.answer || (this.question.answer && this.question.answer.grade === null )) return true;
        },
        exercise() {
            return this.$store.getters.LOADED_EXERCISE;
        },
        color() {
            return this.$store.getters.COLOR;
        }
    },
    mounted() {
        let answer = this.question.answer ? this.question.answer.text : null;
        if (answer) return (this.answer = answer);
        this.firstLoad = true;
    }
};
</script>

<style>
    .answer p > img,
    .justify p > img {
        width: 100%;
    }
    .answer {
        padding: 10px;
        max-height: 200px;
        overflow: auto;
        background-color: #f4f5f7;
    }
</style>